import { render, staticRenderFns } from "./agingTable.vue?vue&type=template&id=5127550a&scoped=true"
import script from "./agingTable.vue?vue&type=script&lang=js"
export * from "./agingTable.vue?vue&type=script&lang=js"
import style0 from "./agingTable.vue?vue&type=style&index=0&id=5127550a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5127550a",
  null
  
)

export default component.exports